<template lang="html">
  <content-div>
    <step-bar :step="step" title="결제하기"></step-bar>
    <div class="contArea subscApplyReq">
      <div class="titWrap">
        <h3 class="conTit1">가입 정보 확인</h3>
      </div>

      <pkg-item-subsc-apply-req-view @costCal="getPriceCom" @wrongSlugCode="promoSlugInvalid"></pkg-item-subsc-apply-req-view>

      <!-- <div class="subBlock"></div> -->

      <radio-input
          ref='cardType'
          :title="'결제카드종류'"
          :title-class="'conTit1 non'"
          :lists="cardTypeList"
          :selected="selectCardType"
          :val.sync="selectCardType"
          :option-val-id="true"
          >
      </radio-input>

      <div class="titWrap">
        <h3 class="conTit1">결제</h3>
        <small style="margin-left:10px; color: #7f8081; font-size:12px;">구매하실 멤버십의 판매자를 선택해 주세요</small>
      </div>

      <div class="infoTable02">
        <ul class="listDot">
          <li class="WBkeepAll" style="font-size:12px; color:red;">본 멤버십 서비스는 선택하신 판매자와 상관없이 모든 서비스센터에서 이용이 가능합니다.</li>
        </ul>
      </div>

      <div class="selectBox" style="margin-top:10px;">
        <SelectRadioPopup
          title="판매자를 선택해 주세요"
          :items="dealers"
          :selected="selectDealer"
          :val.sync="selectDealer"
        ></SelectRadioPopup>
      </div>


      <div class="titWrap">
        <h3 class="conTit1">추천인 등록</h3>
      </div>

      <div class="selectBox" style="margin-top:10px;">
        <div :class="[advisor ? 'wrapInp disabled' : 'wrapInp']" @click="openAdvisorSearch">
          <input type="text" :value="selectAdvisorTitle" placeholder="추천인을 등록해주세요." disabled>
        </div>
        <button type="button" class="advisorSearchButton btnSearch" @click="openAdvisorSearch"></button>
      </div>

      <advisor-search-dialog
          v-bind:activated="activateAdvisor"
          v-bind:dealer="dealers[selectDealer]"
          @ok="searchedAdvisor"
          @cancel="closedAdvisor"
      />

      <div class="infoTable02" v-if="(typeof dealers[selectDealer] != 'undefined' && dealers[selectDealer].options.title)">
        <ul>
          <li><em>상호</em><span>{{dealers[selectDealer].options.title}}</span></li>
          <li><em>사업자 번호</em><span>{{dealers[selectDealer].options.num}}</span></li>
          <li style="word-break:keep-all;"><em>소재지</em><span>{{dealers[selectDealer].options.addr}}</span></li>
          <li><em>대표자</em><span>{{dealers[selectDealer].options.ceo}}</span></li>
          <li><em>연락처</em><span>{{dealers[selectDealer].options.tel}}</span></li>
          <li><em>통신판매업<br>신고번호</em><span>{{dealers[selectDealer].options.business_num}}</span></li>
        </ul>
      </div>

      <term-service-view :terms="terms"  all_check_title=""></term-service-view>
 
      <ul class="listDot mgt2">
        <li>{{$store.state.msg_}}</li>
      </ul>

      <button-apply :before="backRoute" >
        <span><a class="btnL" @click="submit()">결제하기</a></span>
      </button-apply>
    </div>

    <popup-alert v-if="activate" title="알림" @close="popupAlertClose">
      <popup-msg :type="activateMsg"></popup-msg>
    </popup-alert>

    <popup-alert v-if="popup.warnCheck" title="주의사항" :btn_close="true" @close="warnCheckAgree">
      <popup-msg :type="popup.warnType" @action="warnCheckAction"></popup-msg>
    </popup-alert>

    <popup v-if="advisorConfirm">
      <template #title>추천인 선택</template>
      <template #content>
        추천인을 선택하지 않으셨습니다.<br/>
        계속 진행 하시겠습니까?
      </template>

      <template #button>
        <span><a @click="advisorConfirm=false">아니요</a></span>
        <span><a @click="advisorConfirm=false; submit();" class="fCol1">네</a></span>
      </template>

    </popup>

    <popup-alert v-if="popup.warnCancel" title="안내" @close="popup.warnCancel=false;">
      <p>주의사항 확인 체크 후 다음 단계로 진행이 가능합니다.</p>
    </popup-alert>

  </content-div>
</template>


<script>
  import axios from "axios";
  import {api} from "@/api";
  import Const from '../../../helpers/Const'

  import ButtonApply from "@/components/Button/ButtonSubscApply.vue";
  import InputForm from "@/components/Input/InputForm.vue";
  import SelectInput from "@/components/Input/SelectInput.vue";
  import SelectRadioPopup from "@/components/Select/SelectRadioPopup.vue";
  import RadioInput from '@/components/Input/RadioInput.vue';

  import StepBar from "@/components/StepBar.vue";
  import PkgItemSubscApplyReqView from "@/views/Pkg/PkgItemSubscApplyReqView";
  import TermServiceView from "@/views/Term/TermServiceView";
  import PopupAlert from '@/components/Popup/PopupAlert.vue';
  import PopupMsg from "@/components/Popup/PopupMsgTemplate";
  import Popup from "@/components/Popup/Popup";

  import AdvisorSearchDialog from './components/AdvisorSearchDialog';

  import SubscApplyReqConst from "./SubscApplyReqConst";


  export default {
    // navigation guard
    beforeRouteEnter(to, from, next) {
      // 결제완료 후 이전버튼 클릭 등 직전 페이지 외에 페이지에서 접근 시 접근 제어 20.03.24  sang
      // 서비스상품 선택 화면에서 Light 선택 시 바로 결제화면
      // 가입 실패시 가입화면으로 간다.
      // if (
      //     false &
      //   from.name != 'SubscApplyPkg' &&            // 구독 상품 선택
      //   from.name != 'SubscApplyVehiclePanel' &&   // 구독 신청 계기판 촬영
      //   from.name != 'Layover' &&                  // 결제결과 경유
      //   from.name != 'SubscGuide'                  // test guide
      // ) {
      //   alert('잘못된 경로로 접근하였습니다.\n확인을 누르시면 결제진행이 취소되며 메인화면으로 이동합니다.');
      //   this.$store.commit("unsetTerms");
      //   axios.get(`${api.users}/getClientIp`).then((res) => { location.href = res.data.hostPlus;})
      // } else {
        next();
      // }
    },

    beforeRouteLeave (to, from, next) {
      
      if(this.selectDealer)
        this.$store.commit('setSubscDaelerCdkId',this.dealers[this.selectDealer].id);

      if(to.name == 'Layover') {
        next(this.backRoute);
      } else {
        next();
      }

    },

    components: {
      ButtonApply,
      PopupAlert,
      InputForm,
      PkgItemSubscApplyReqView,
      PopupMsg,
      StepBar,
      TermServiceView,
      SelectInput,
      SelectRadioPopup,
      Popup,
      RadioInput,
      AdvisorSearchDialog
    },

    computed: {
      checkAll: {
        get() {
          for (let i in this.terms) {
            if (!this.terms[i].checked)
              return false;
          }
          return true;
        },
        set(val) {
          for (let i in this.terms) {
            this.terms[i].checked = val;
          }
        },
      },
      date() {
        let month = [];
        let i = 12;
        let m = 1;
        //if (this.today.year == this.itemCard.year.val) m = this.today.month;
        for (i; i >= m; i--) month.push({val: i, title: i});
        let year = [];
        let j = this.today.year;
        for (j; j <= 2030; j++) year.push({val: j, title: j});
        let date = new Object();
        date.month = month;
        date.year = year;
        return date;
      },
      backRoute(){
        const isAssurance = this.$store.state.pkg.is_assurance;
        if (!isAssurance) { //FIXME!!
          return '/subscApply/pkg';
        } else
          return '/subscApply/vehiclePanel';
      },
    },

    created() {
      this.step = Number(this.$route.query.step || this.$store.state.subsc.payments.step);

      window.scroll(0, 0);
      this.getDealerCdks();

      let d = new Date();
      this.today.month = d.getMonth() + 1;
      this.today.year = d.getFullYear();
      //this.itemCard.month.val = d.getMonth() + 1;
      //this.itemCard.year.val = d.getFullYear();
    },

    mounted() {
      if(this.$store.state.pkg.is_assurance){
        this.popup.warnType = 'INSP_PANEL_PHOTO_WARNING'
      }else{
        this.popup.warnType = 'INSP_PANEL_NORMAL_WARNING'
      }
    },

    data() {
      return {
        activate: false,
        activateMsg: '',
        advisorConfirm: false,
        advisor: '',
        dealers: [],
        //itemCard: SubscApplyReqConst.ITEM_CARD,
        itemPayment: {
          payment: '', //총결제금액
          promo: '', //신규or할인정보
          promo_code: '',//코드할인정보
        },
        selectDealer: '',
        terms: SubscApplyReqConst.TERMS,
        termsOn: false,
        today: {month: "", year: ""},

        popup: {
          warnCheck: false,
          warnCancel: false,
          warnType: null,
        },
        activateAdvisor: false,
        selectAdvisor: null,
        selectAdvisorTitle: '',
        
        cardTypeList: Const.getPaymentCardType(),
        selectCardType : Const.CARD_TYPE.DEF,

        warnCheck: false,
        step:3,
      };
    },

    watch: {
      selectDealer: function(newVal, oldVal){
        this.selectDealer = newVal;
        if(newVal !== oldVal){
          this.selectAdvisorTitle = '';
          this.selectAdvisor = null;
        }
      }
    },

    methods: {
      openAdvisorSearch() {
        if (this.selectDealer !== '' && this.selectDealer !== null){
          this.activateAdvisor = true;
        } else {
          this.activateMsg = '구매하실 상품의 판매자를 먼저 선택해주세요.';
          this.activate = true;
        }
      },

      searchedAdvisor(selectAdvisor, selectAdvisorTitle) {
        this.activateAdvisor = false;
        this.selectAdvisorTitle = selectAdvisorTitle;
        this.selectAdvisor = selectAdvisor;
      },

      closedAdvisor(){
        this.activateAdvisor = false;
      },

      popupAlertClose() {
        this.activate = false;
        this.activateMsg = '';
      },

      getDealerCdks() {
        axios.get(api.dealerCdks).then(({data}) => {
          // 테스트 환경이 아닐 경우 에피카 모터스 미노출 //TODO: 서버에서 처리
          //if (!this.$store.state.isDev) data.data.shift();
          this.dealers = data.data.sort(() => Math.random() - 0.5);

          //이전 선택한 딜러가 있을경우 보정
          if(this.$store.state.dealer_cdk_id != 0){
            let dealer = this.dealers.map(function(e) { return e.id; })
            let idx = dealer.indexOf(this.$store.state.subsc.dealer_cdk_id);
            this.selectDealer = (idx == -1) ? '' : idx;
          }
        })
          .catch(({response}) => {
            this.activateMsg = `[${response.status}] 딜러사 리스트를 불러오지 못했습니다.`;
            this.activate = true;
          })
      },

      // 컴포넌트에서 계산한 금액관련 데이터들.. temp       20.03.25    sang
      getPriceCom(val) {
        this.itemPayment = val;
      },

      // 해당하지 않는 쿠폰코드 입력 시
      promoSlugInvalid(error_msg) {
        this.activateMsg = error_msg;
        this.activate = true;
      },

      confirmAdvisor(){
        this.advisorConfirm = true;
      },

      submit() {
        if(this.selectDealer === '') {
          this.activateMsg = 'SUBSC_REQ_DEALER';
          this.activate = true;
          return;
        }

        if(this.selectAdvisor === null) {
          this.activateMsg = 'SUBSC_REQ_ADVISOR';
          this.activate = true;
          return;
        }
        
        if(this.selectCardType == Const.CARD_TYPE.COM 
          && this.dealers[this.selectDealer] 
          && this.dealers[this.selectDealer]['co_card_yn'] == 'N') {
          this.activateMsg = 'SUBSC_REQ_DEALER_NOT_CO_CARD';
          this.activate = true;
          return;
        }

        for (let i in this.terms) {
          if (!(this.terms[i].checked || !this.terms[i].required)) {
            this.activateMsg = 'NEED_SUBSC_TERM_CHECK';
            this.activate = true;
            return;
          }
        }

        this.popup.warnCheck = true;
        // this.set();
      },

      warnCheckAction(value){
        this.warnCheck = value;
      },

      warnCheckAgree(){
        this.popup.warnCheck = false;
        if (!this.warnCheck) {
          this.popup.warnCancel = true;
        } else {
          this.set();
        }
      },

      set() {
        this.$store.commit("setPayment", {
          date: this.$moment().format('YYYY-MM-DD HH:mm:ss'),     //결제일
          num: this.$moment().format('MMDDHHmmss'),               //결제(주문)번호(pg return 값 예상)
          price_pkg: this.$store.state.subsc.payments.price_pkg,          // 결제당시 패키지 금액(소비자가)
          promo: this.itemPayment.promo,        // 신규 or 연장 할인정보
          promo_code: this.itemPayment.promo_code,  // 코드할인 정보
          price_payment: this.itemPayment.payment,      // 실제결제금액
          card_type:this.selectCardType, //결제카드종류
          terms: {
            pay_personal: this.terms[0].checked,
          },
          step: this.step,
        });
        this.$store.state.subsc.dealer_cdk_id = this.dealers[this.selectDealer].id;

        if (this.selectAdvisor !== null)
          this.$store.state.subscRecommendedAdvisor.user_id = this.selectAdvisor.id;
        this.setItem();
      },

      // server에서 결제
      setItem() {
        if(this.$store.state.btnLoading) return;
        this.$store.commit('setBtnLoading', true);

        axios.post(api.subscs, this.$store.getters.getSubsc)
        .then((res) => {
          this.$store.commit('setBtnLoading', true);
          const url = res.data.data.redirect;
          if(url) window.location = url;
        })
        .catch(({response}) => {
          this.warnCheck = false;
          const msg = response.data.data.msg;
          const statusCode = response.data.data.status_code;
          if(typeof msg != 'undefined'){
            //PM_SUBSC_EXISTS = 5011; //구독있음 ERROR CODE

            if(Const.getErrorCodes().includes(statusCode)) {
              this.activateMsg = msg;
              this.activate = true;
              return;
            }
          }

          this.activateMsg = `[${response.status}] ${response.statusText}`;
          this.activate = true;

        });
      },
    },
  };
</script>

<style>
/* 추천인 검색 버튼  */
.subscApplyReq .advisorSearchButton{
  margin-top: -39px;
  position: absolute;
  right: 6px;
  width: 32px;
  height: 32px;
}
</style>